import { getApplicationDisplayName } from '@frontend/functionality/utils';
import type { ReactNode } from 'react';

/** Top-right app switcher label: account name; My prefixes with the My app label. */
export function getHeaderAccountLabel(options: { currentApp: string | null | undefined; accountName: string | null | undefined }): ReactNode {
    const name = options.accountName?.trim() || null;

    if (options.currentApp === 'my') {
        return (
            <>
                {getApplicationDisplayName('my')}
                {name ? ` ${name}` : ''}
            </>
        );
    }

    return name;
}
